import { Hammer, Home, Truck, Wrench } from "lucide-react";

const SERVICES = [
  {
    icon: Home,
    title: "Indoor Assembly",
    body: "Basements, bathrooms, home gyms — we protect flooring, coordinate electrical, and finish trims cleanly.",
  },
  {
    icon: Hammer,
    title: "Outdoor Assembly",
    body: "Barrel, cabin, cube and A-frame builds. Leveled foundations, weather-sealed joints, chimney fittings.",
  },
  {
    icon: Truck,
    title: "Disassembly & Relocation",
    body: "Moving home? We disassemble, transport, and reinstall — every panel and stone documented.",
  },
  {
    icon: Wrench,
    title: "Maintenance & Tune-Ups",
    body: "Heater diagnostics, gasket replacement, resealing, and annual wood-care for lasting warmth.",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="border-t border-[#E5E0D8] bg-bone">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <p className="overline mb-5">What we do</p>
            <h2 className="font-serif-display font-light text-4xl md:text-5xl text-text-main leading-tight">
              Every model, every setting — <span className="italic text-cedar">handled with care.</span>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-text-muted text-base md:text-lg leading-relaxed">
              We work with saunas from all major manufacturers — Harvia, Almost Heaven, Dundalk, Auroom,
              Klafs, and beyond. If you&apos;ve bought it, we can assemble it.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((s, i) => (
            <div
              key={s.title}
              data-testid={`service-card-${i}`}
              className="hover-lift bg-surface border border-[#E5E0D8] p-8 flex flex-col h-full"
            >
              <s.icon size={28} strokeWidth={1.5} className="text-cedar" />
              <h3 className="font-serif-display text-2xl mt-6 text-text-main">{s.title}</h3>
              <p className="text-text-muted text-sm leading-relaxed mt-4">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
